import {
    NgModule,
    Component,
    Input,
    ChangeDetectionStrategy,
    ViewChild,
    ChangeDetectorRef,
    OnDestroy,
    Inject,
    ElementRef,
    PLATFORM_ID
} from '@angular/core';
import { trigger, transition, style, animate, query, stagger } from '@angular/animations';

import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute } from '@angular/router';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import 'rxjs/add/observable/fromEvent';
import { DEVICE_INFO, DeviceInfo } from 'angular-engine/modules/ng-express-engine/tokens';
@Component({
    selector: 'episode-carousel',
    templateUrl: 'episode-carousel.template.html',
    styleUrls: ['episode-carousel.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('listAnimation', [
            transition('* => *', [ // each time the binding value changes
                query('.swiper-slide', style({ opacity: 0 }),{optional:true}),
                query('.swiper-slide', stagger('200ms', [
                    animate('300ms 0.5s ease-out', style({ opacity: 1 }))
                ]),{optional:true}),
            ])
        ])
    ]
})
export class EpisodeCarousel {
    @Input() item: any;
    @Input() slides: Array<any>;
    @Input() clickDisabled: boolean;

    public config: any;
    private selectedIndex: number = 0;
    public ready: boolean;
    private isServer: boolean;

    @ViewChild('scrollbar') swiperScrollbar;
    constructor(
        @Inject(PLATFORM_ID) platformId: string,
        @Inject(DEVICE_INFO) private deviceInfo: DeviceInfo,
        private coreEffects: CoreEffects,
        private cd: ChangeDetectorRef,
        private route: ActivatedRoute,
        private el: ElementRef) {
        this.isServer = isPlatformServer(platformId);
        this.el = el;
    }

    get isMobile(): boolean {
        return this.deviceInfo.isMobile;
    }

    getClickable(preference:boolean):boolean {
        if(this.clickDisabled)
            return false;

        return preference;
    }

    getSeasonSlide(slide:any):any {
        if(!this.clickDisabled){
            if(!slide.url && !slide.internal_route)
            {
                slide.internal_route = "/seasons/" + slide.slug;
            }
        }

        return slide;
    }

    ngOnInit() {
        this.config = {
        };
    }

    ngAfterViewInit() {
        this.ready = true;
        this.cd.detectChanges()
    }

    private getSwiperSlideClass(slide): string {
        var objType = ((slide.meta || slide).obj_type || "").toLowerCase();
        
        objType += objType === "array" && slide.data.length > 2 ? " -long" : "";
        return objType;
    }

    ngOnDestroy() {
        this.config = null
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/series/episode-carousel/episode-carousel.component.ts